import { WebClient } from "@cisco/spaces-dash-lib-web";

const CACHE_EXPIRATION_TIME = 2000;
const MAX_RETRIES = 2;
const isFetching = {};
const cache = {};

const waitForFetchCompletion = (endpoint) => {
  return new Promise((resolve) => {
    const intervalId = setInterval(() => {
      if (!isFetching[endpoint]) {
        clearInterval(intervalId);
        resolve();
      }
    }, 100);
  });
};

const fetchData = async (endpoint, retryCount = 0) => {
  const currentTime = new Date().getTime();

  if (cache[endpoint] && currentTime - cache[endpoint].timestamp < CACHE_EXPIRATION_TIME) {
    return cache[endpoint].data;
  }

  if (isFetching[endpoint]) {
    // Wait until the fetch operation completes
    await waitForFetchCompletion(endpoint);
    return cache[endpoint]?.data || [];
  }

  isFetching[endpoint] = true;

  try {
    const responseData = await WebClient.get(endpoint);
    cache[endpoint] = { data: responseData, timestamp: currentTime };
    return responseData;
  } catch (error) {
    console.log(`Error fetching data for ${endpoint}. Retry count: ${retryCount}`);
    if (retryCount < MAX_RETRIES) {
      isFetching[endpoint] = false;
      console.log(`Retrying API call for ${endpoint}, retry count: ${retryCount + 1}`);
      return fetchData(endpoint, retryCount + 1);
    }
    console.error(`Maximum retry attempts reached for ${endpoint}`);
    throw error;
  } finally {
    isFetching[endpoint] = false;
  }
};

export const getAdminList = async () => {
  return fetchData("/api/v1/rbac/admins");
};

export const getAdminRoleList = async () => {
  return fetchData("/api/v1/rbac/admin/roles/list");
};

// export const getAdminList = async (callback) => {
//     WebClient
//     .get("/api/v1/rbac/admins")
//     .then((res) => {
//       callback(res?.data);
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

// export const getAdminRoleList = async (callback) => {
//     WebClient
//     .get("/api/v1/rbac/admin/roles/list")
//     .then((res) => {
//         console.log('res')
//       callback(res?.data);
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

export const getUserInfo = async (email, callback) => {
  console.log(callback);
  return WebClient.get(`/api/v1/rbac/admin/getUserInfo/${email}`);
};

export const createAdmin = async (userObj) => {
  return WebClient.post("/api/v1/rbac/admin/invite", {}, userObj);
};

export const getAppsList = () => {
  // WebClient.get("/api/v1/rbac/applications/list").then(data => callback(data)).catch(error => console.log('error', error));
  return fetchData("/api/v1/rbac/applications/list");
};

export const createRole = async (userObj) => {
  return WebClient.post("/api/v1/rbac/admin/role/create", {}, userObj);
};

export const updateRole = async (userObj) => {
  return WebClient.put("/api/v1/rbac/admin/role/update", {}, userObj);
};

export const updateAdmin = async (userObj) => {
  return WebClient.post("/api/v1/rbac/admin/edit", {}, userObj);
};

export const resendInvite = async (userObj) => {
  return WebClient.post("/client/v1/team/resendInvite", {}, userObj);
};
